import lodash from "lodash";
import { createColumnInlineInputNumber, createColumnInlineSelect } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import { conditionFormChecker } from "../../../../../utils/form";
import store from "../../../../../store";

import { callHazPackage } from "../../../haz/request/haz-package/package.logic";
import { createPage } from "../../../../../utils/page";
import { createLoading } from "../../../../../utils/loading";

export const { isLoading, setIsLoading } = createLoading();

export const callQuantityUnit = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "QUANTITY_UNIT", value: searchQuery });

export const createColumns = ({ props, data }) => {
    const { viewOnly, itemsKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    const columns = [];

    columns.push(
        createColumnInlineInputNumber({
            title: () => i18n.global.t("model.manufactureSample.quantity"),
            dataIndex: "quantity",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ allowPrecision: true }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        allowPrecision: true,
                        "onUpdate:value": value => {
                            record.isSave = true;
                            record.quantity = value;
                            modelRef.refManufactureSampleTemp.quantity = value;
                        }
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                ),
            width: 100
        })
    );
    columns.push(
        createColumnInlineSelect({
            title: () => i18n.global.t("model.manufactureSample.refUnit"),
            dataIndex: "refUnit",
            items,
            useForm,
            itemsKey,
            // inputProp: () => ({ list: ({ field }) => lodash.get(modelRef, field.name).refStorageLocation.subs, optLabel: "buildingName" }),
            inputProp: () => ({ list: callQuantityUnit, optLabel: "value" }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        list: callQuantityUnit,
                        optLabel: "value",
                        "onUpdate:value": value => {
                            record.isSave = true;
                            record.refUnit = value;
                            modelRef.refManufactureSampleTemp.refUnit = value;
                        }
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                )
        })
    );
    columns.push(
        createColumnInlineSelect({
            title: () => i18n.global.t("model.manufactureSample.refPackage"),
            dataIndex: "refPackage",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ list: callHazPackage, optLabel: "value" }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        list: callHazPackage,
                        optLabel: "value",
                        "onUpdate:value": value => {
                            record.isSave = true;
                            record.refPackage = value;
                            modelRef.refManufactureSampleTemp.refPackage = value;
                        }
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                )
        })
    );
    return columns;
}

export const initData = ({ props, data }) => {
    const { itemsKey, } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: items });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = []
    data.manageExtras = []
    data.rowActions = []
}